<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs3-04",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 45,
      nextPage: '/questionnaire/section3/5',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        mainTitle: 'How often do you eat vegetables and fruit?',
        btn: [
          [
            {
              text: 'Eat three meals a day',
            }
          ],[
            {
              text: 'Once a day',
            }
          ],[
            {
              text: 'Eat every two or three days',
              operation: 'flag3-1_Anything_add suggestion 7'
            }
          ],[
            {
              text: 'Rarely',
              operation: 'flag3-1_Anything_add suggestion 7'
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
